import * as actionTypes from './actionsTypes';


export const setAuthDetails = (userDetails) => {
    return {
        type: actionTypes.SAVEUSERDETAILS,
        data: userDetails
    }
}